<template>
    <IQOSTable 
      :cols="[{
        title: $t('subscription.transactions.date'),
        key: 'created_at',
        date: true
      }, {
        title: $t('subscription.transactions.time'),
        key: 'created_at',
        time: true
      }, {
        title: $t('subscription.transactions.system'),
        key: 'mode',
        renderer: (r) => `${(r.mode || '').toUpperCase()}`
      }, {
        title: $t('subscription.transactions.sum'),
        key: 'total',
        currency: 'code'
      }, {
        title: $t('subscription.transactions.commission'),
        unit: '%',
        key: 'comission'
      }]" 
      :rows="transactions"/>
    <!-- <thead>
      <th>{{$t('subscription.transactions.date')}}</th>
      <th>{{$t('subscription.transactions.time')}}</th>
      <th>{{$t('subscription.transactions.system')}}</th>
      <th>{{$t('subscription.transactions.method')}}</th>
      <th>{{$t('subscription.transactions.sum')}}</th>
      <th>{{$t('subscription.transactions.commission')}}</th>
      <th>{{$t('subscription.transactions.commission')}}</th>
      <th>{{$t('subscription.transactions.balance')}}</th>
    </thead>
    <tbody>
      <tr v-for="item in transactions" :key="item._id">
        <td>{{ item.created_at | formatDate }}</td>
        <td>{{ item.created_at | formatTime}}</td>
        <td>
          <span v-if="item.mode">{{ item.mode.toUpperCase() }}</span>
        </td>
        <td>
          <div v-if="item.amount < 0">
            <span v-if="item.pay_method == 'cash'">{{$t('subscription.transactions.cash')}}</span>
            <span v-if="item.pay_method == 'card'">{{$t('subscription.transactions.terminal')}}</span>
            <span v-if="item.pay_method == 'online'">{{$t('subscription.transactions.online')}}</span>
          </div>
        </td>
        <td>
            <span v-if="item.total">
                {{ item.total }} {{currency.iso_code}}
            </span>
        </td>
        <td>
            <span v-if="item.amount < 0"> {{ item.comission }}%</span>
        </td>
        <td>
            <span v-if="item.amount < 0"> {{ item.amount }} {{currency.iso_code}}</span>
        </td>
        <td>
            {{ item.balance }} {{currency.iso_code}}
        </td>
      </tr> 
    </tbody>
  </table>-->
</template>

<script>
import BillingAPI from "@/api/billing";

import { saveAs } from "file-saver";

import moment from 'moment'

export default {
  data() {
    return {
      transactions: []
    };
  },
  methods: {
    fetchData() {
      BillingAPI.getTransactions()
        .then(data => {
          this.transactions = data.transactions;
        })
        .catch(error => {
          this.$store.dispatch("showError", "billing_fetch");
        });
    },
    exportToCsv() {
      let csv = `Дата,Час,Система,Метод оплати,Сума,Комісія,Комісія,Баланс\n`;

      this.transactions.forEach((item, index) => {
        const fields = [
          moment(item.created_at).format('DD.MM.YYYY'),
          moment(item.created_at).format('HH:mm'),
          item.mode,
          item.pay_method,
          item.total,
          `${item.comission}%`,
          item.amount,
          item.balance
        ];

        csv += fields.map(f => `"${f}"`).join(",") + "\n";
      });

      const blob = new Blob([csv], {
        type: "text/csv"
      });

      saveAs(blob, `marketplace-transactions-${Date.now()}.csv`);
    },
  },
  computed: {
    currency() {
      return this.$store.state.currency;
    }
  },
  mounted() {
    this.fetchData();
  }
};
</script>

<style>
</style>